"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CountryFlag = require("./CountryFlag");
Object.keys(_CountryFlag).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CountryFlag[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CountryFlag[key];
    }
  });
});